/**
 * 菜单
 */

export default [
  {
    path: '',
    name: '平台设置',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    children:[
      {
        path: '/customer/toCustomerInfo.action',
        name: '公司信息',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/pub/pubIndex.vue`),
        meta: {
          permission: ['set_company']
        }
      },
      {
        path: '/pms/userInfoList.action',
        name: '账户设置',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/pub/pubIndex.vue`),
        meta: {
          permission: ['set_user_info']
        }
      },{
        path: '/pms/roleInfoList.action',
        name: 'HR权限设置',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/pub/pubIndex.vue`),
        meta: {
          permission: ['set_role']
        }
      },{
        path: '/pms/userRoleList.action',
        name: '用户授权',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/pub/pubIndex.vue`),
        meta: {
          permission: ['set_user_permission']
        }
      },{
      path: '/sys/queryParameter.action',
        name: '系统设置',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/pub/pubIndex.vue`),
        meta: {
          permission: ['set_system']
        }
      },{
        path: '/sys/infoSet/toJSP.action',
        name: '消息设置',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/pub/pubIndex.vue`),
        meta: {
          permission: ['set_message']
        }
      },
      // {
      //   path: '/sys/compnotice/queryList.action',
      //   name: '客户公告',
      //   component: () => import(/* webpackChunkName: "step2" */ `@/views/pub/pubIndex.vue`),
      //   meta:{
      //     crossOrigin:true  //启动跨域设置
      //   }
      // },
      {
        path: '/pms/userRoleInfoList.action',
        name: '员工权限管理',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/pub/pubIndex.vue`),
        meta: {
          permission: ['set_emp_permission']
        }
      },
    ]
  },
  {
    path: '',
      name: '人力资源设置',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    children:[
    {
      path: '/atndset/toindex.action',
      name: '考勤设置',
      component: () => import ( /* webpackChunkName: "step2" */ `@/views/pub/pubIndex.vue`),
      meta: {
        permission: ['set_atnd']
      }
  },
    {
      path: '/vacnstandard/toindex.action',
        name: '休假设置',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/pub/pubIndex.vue`),
        meta: {
          permission: ['set_vanc']
        }
    },
    {
      path: '/approval/toindex.action',
        name: '审批设置',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/pub/pubIndex.vue`),
        meta: {
          permission: ['set_approve']
        }
    }
  ]
  },
  {
    path: '',
    name: '政策字典',
    component: () => import ( `@/views/pub/pubIndex.vue`),
    children:[
    {
      path: '/bsoc/bsocPolicyDic_init.action',
      name: '社保政策',
      component: () => import ( `@/views/pub/pubIndex.vue`),
      meta: {
        permission: ['social_security_policy','provident_fund_policy']
      }
    }
  ]
  }
];
